var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
define('areas/activityfeed/parts/getcpmtoken',["require", "exports", "common/parts", "areas/activityfeed/models/dto"], function (require, exports, Parts, Dto) {
    "use strict";
    var GetCPMToken = (function (_super) {
        __extends(GetCPMToken, _super);
        function GetCPMToken(baseUrl) {
            _super.call(this);
            this._baseUrl = baseUrl;
        }
        GetCPMToken.prototype.process = function (symbol) {
            var _this = this;
            try {
                var url = this._baseUrl + "/sdn/oauth/token?response_type=code&grant_type=password";
                var data = { clientnumber: symbol.clientnumber, username: symbol.username, password: symbol.password };
                Q(jQuery.ajax(url, {
                    type: "POST",
                    async: true,
                    contentType: "application/x-www-form-urlencoded",
                    data: data
                }))
                    .then(function (response) {
                    var result = new Dto.TokenResponse();
                    result.token.access_token = response.access_token;
                    result.token.refresh_token = response.refresh_token;
                    _this.output.call(result);
                });
            }
            catch (error) {
                this.error.call(error);
            }
        };
        return GetCPMToken;
    }(Parts.Part));
    return GetCPMToken;
});

